
import React from "react";
import { Coins } from "lucide-react";
import { Reagent } from "@/services/reagentService";
import { Profile } from "@/services/profiles";

interface SwapFormHeaderProps {
  reagent: Reagent;
  profile: Profile | null;
}

const SwapFormHeader: React.FC<SwapFormHeaderProps> = ({ reagent, profile }) => {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4">Request Swap for {reagent.name}</h2>
      
      {profile && (
        <div className="bg-muted/50 p-3 rounded-md mb-4">
          <p className="text-sm flex items-center gap-1">
            <Coins className="h-4 w-4 text-amber-500" />
            <span>Your available credit balance: <strong>{profile.credit_balance}</strong></span>
          </p>
        </div>
      )}
    </>
  );
};

export default SwapFormHeader;
